import styled from 'styled-components';

export const FilterOptionsWrapper = styled.div`
  padding: 8px 12px 10px;
`;

export const FilterActionsWrapper = styled.div`
  padding: 6px;
`;
